export default "__VITE_ASSET__B0rqi$op__"